export const SLOT_ORDER = ['rod', 'reel', 'line', 'lure', 'float'];
/** Какие гнёзда занимает комплект. Порядок — как в инвентаре. */
export const КОМПЛЕКТ_ГНЁЗДА = {
    спиннинг: ['rod', 'reel', 'line', 'lure'],
    удочка: ['rod', 'float', 'line', 'lure'],
    болонская: ['rod', 'reel', 'float', 'line', 'lure'],
    фидер: ['rod', 'reel', 'line', 'lure'],
};
/**
 * Есть ли у этого класса катушка.
 *
 * ⚠️ ПЕРЕЧИСЛЕНЫ ТЕ, У КОГО ЕЁ НЕТ, А НЕ ТЕ, У КОГО ЕСТЬ. Список безкатушечных
 * закрыт и короток — мах да штекер; список остальных будет расти с каждым
 * новым спиннингом, и однажды кто-то забудет дописать туда свой класс. Забыть
 * здесь — значит молча снять с новой снасти катушку вместе с кольцами.
 */
export function сКатушкойЛи(kind) {
    return kind !== 'float' && kind !== 'pole';
}
/** Ловят ли этим классом на поплавок. */
export function подПоплавокЛи(kind) {
    return kind === 'float' || kind === 'pole' || kind === 'bolo' || kind === 'match';
}
/**
 * Какой комплект собирают под это удилище.
 *
 * ⚠️ ЗДЕСЬ ЕДИНСТВЕННОЕ МЕСТО, ГДЕ КЛАСС ПРЕВРАЩАЕТСЯ В КОМПЛЕКТ. И сервер, и
 * игра спрашивают отсюда: разойдись они хоть раз — на экране снаряжения
 * появились бы гнёзда одного набора, а на воде работал бы другой.
 */
export function комплектУдилища(kind) {
    if (!сКатушкойЛи(kind))
        return 'удочка';
    if (подПоплавокЛи(kind))
        return 'болонская';
    return kind === 'feeder' ? 'фидер' : 'спиннинг';
}
/**
 * СНАСТЬ, КОТОРОЙ ИГРАЮТ СЕЙЧАС.
 *
 * ⚠️ ЭТИ ЧЕТЫРЕ ЗАПИСИ — СЛЕПОК НЫНЕШНЕГО СОСТОЯНИЯ ИГРЫ, И МЕНЯТЬ ИХ
 * НЕЛЬЗЯ. Числа сняты с кода один в один:
 *
 *   удилище   ROD_KINDS.medium                 rod-view.ts   (2.40 м, 30 г)
 *   катушка   dragMaxKg() / reelMaxMps()       reel-dial.ts  (5 кг, 2 м/с)
 *             SPOOL_LINE_DEFAULT_M             casting.ts    (100 м)
 *   леска     lineMaterial / lineDiameterMm    casting.ts    (mono, 0.24 мм)
 *   приманка  lureSpec.kind / defaultMassG     casting.ts, lure.ts (spoon, 18 г)
 *             wobblerDepthM                    casting.ts    (2.0 м)
 *
 * ⚠️ ССЫЛКИ ЗДЕСЬ ПО ИМЕНАМ, А НЕ ПО НОМЕРАМ СТРОК. Номера гниют с первой
 * же правкой соседнего кода, и сверять по ним потом невозможно; имя ищется
 * поиском и остаётся верным.
 *
 * Смысл слепка в том, что игрок БЕЗ инвентаря и игрок с надетым стартовым
 * набором должны получить одну и ту же снасть до последнего знака. Это
 * проверяется при запуске (см. `checkStockTackle` на клиенте): разошлось —
 * значит инвентарь тихо переписал то, что подбиралось руками.
 */
export const STOCK_ITEMS = {
    rod: 'rod.medium.stock',
    reel: 'reel.stock',
    line: 'line.mono.024',
    lure: 'lure.spoon.18',
    /**
     * ⚠️ ПОПЛАВОК В СТАРТОВОМ НАБОРЕ ЕСТЬ, А УДОЧКИ НЕТ, И ЭТО НАМЕРЕННО.
     * Спиннинг выдаётся новичку целиком — им и начинают. Удочку покупают, и
     * покупка эта осмысленна: она открывает две трети справочника рыбы. А вот
     * поплавок с червём лежат в рюкзаке сразу — иначе купленная удочка
     * оказалась бы бесполезной до второй покупки, и первое впечатление от неё
     * было бы «не работает».
     */
    float: 'float_light_1g',
};
/** Ключ посадки нынешней снасти. Файлы поз — rod-pose.json, reel-pose.json. */
export const STOCK_POSE = 'stock';
export const ITEMS = [
    // ── Удилища ───────────────────────────────────────────────────────────
    {
        id: 'rod.medium.stock',
        slot: 'rod',
        nameKey: 'item.rod_medium',
        priceCoins: 250,
        starter: true,
        reqLevel: 1,
        poseKey: STOCK_POSE,
        stats: { kind: 'medium', lengthM: 2.4, testMaxG: 30, action: 'medium' },
    },
    {
        id: 'rod.ultralight',
        slot: 'rod',
        nameKey: 'item.rod_ultralight',
        priceCoins: 450,
        reqLevel: 3,
        poseKey: STOCK_POSE,
        stats: { kind: 'ultralight', lengthM: 1.98, testMaxG: 7, action: 'slow' },
    },
    {
        id: 'rod.light',
        slot: 'rod',
        nameKey: 'item.rod_light',
        priceCoins: 700,
        reqLevel: 5,
        poseKey: STOCK_POSE,
        stats: { kind: 'light', lengthM: 2.13, testMaxG: 12, action: 'medium' },
    },
    {
        id: 'rod.heavy',
        slot: 'rod',
        nameKey: 'item.rod_heavy',
        priceCoins: 1400,
        reqLevel: 10,
        poseKey: STOCK_POSE,
        stats: { kind: 'heavy', lengthM: 2.7, testMaxG: 60, action: 'fast' },
    },
    // ── Катушки ───────────────────────────────────────────────────────────
    {
        id: 'reel.stock',
        slot: 'reel',
        nameKey: 'item.reel_stock',
        priceCoins: 400,
        starter: true,
        reqLevel: 1,
        poseKey: STOCK_POSE,
        stats: { dragMaxKg: 5, reelMaxMps: 2, spoolLineM: 100 },
    },
    {
        id: 'reel.3000',
        slot: 'reel',
        nameKey: 'item.reel_3000',
        priceCoins: 900,
        reqLevel: 6,
        poseKey: STOCK_POSE,
        stats: { dragMaxKg: 7, reelMaxMps: 2.2, spoolLineM: 140 },
    },
    {
        id: 'reel.4000',
        slot: 'reel',
        nameKey: 'item.reel_4000',
        priceCoins: 2200,
        reqLevel: 12,
        poseKey: STOCK_POSE,
        stats: { dragMaxKg: 10, reelMaxMps: 2.5, spoolLineM: 180 },
    },
    // ── Лески ─────────────────────────────────────────────────────────────
    // Разрывная не пишется: она считается из диаметра и материала. Плетёнка
    // при равном диаметре держит втрое против монофила — это и есть причина
    // её покупать, а не приписанное число.
    {
        id: 'line.mono.024',
        slot: 'line',
        nameKey: 'item.line_mono_024',
        priceCoins: 60,
        starter: true,
        reqLevel: 1,
        poseKey: STOCK_POSE,
        stats: { material: 'mono', diameterMm: 0.24 },
    },
    {
        id: 'line.mono.030',
        slot: 'line',
        nameKey: 'item.line_mono_030',
        priceCoins: 120,
        reqLevel: 2,
        poseKey: STOCK_POSE,
        stats: { material: 'mono', diameterMm: 0.3 },
    },
    {
        id: 'line.fluoro.022',
        slot: 'line',
        nameKey: 'item.line_fluoro_022',
        priceCoins: 380,
        reqLevel: 4,
        poseKey: STOCK_POSE,
        stats: { material: 'fluoro', diameterMm: 0.22 },
    },
    {
        id: 'line.braid.014',
        slot: 'line',
        nameKey: 'item.line_braid_014',
        priceCoins: 650,
        reqLevel: 7,
        poseKey: STOCK_POSE,
        stats: { material: 'braid', diameterMm: 0.14 },
    },
    {
        id: 'line.braid.020',
        slot: 'line',
        nameKey: 'item.line_braid_020',
        priceCoins: 1100,
        reqLevel: 11,
        poseKey: STOCK_POSE,
        stats: { material: 'braid', diameterMm: 0.2 },
    },
    // ── Приманки ──────────────────────────────────────────────────────────
    // Массы — те, с какими эти приманки ставят на самом деле (lure.ts).
    {
        id: 'lure.spoon.18',
        slot: 'lure',
        nameKey: 'item.lure_spoon_18',
        priceCoins: 70,
        starter: true,
        reqLevel: 1,
        poseKey: STOCK_POSE,
        stats: { kind: 'spoon', massG: 18, diveM: 2 },
    },
    {
        id: 'lure.spinner.8',
        slot: 'lure',
        nameKey: 'item.lure_spinner_8',
        priceCoins: 90,
        reqLevel: 1,
        poseKey: STOCK_POSE,
        stats: { kind: 'spinner', massG: 8, diveM: 1.2 },
    },
    {
        id: 'lure.wobbler.12',
        slot: 'lure',
        nameKey: 'item.lure_wobbler_12',
        priceCoins: 240,
        reqLevel: 3,
        poseKey: STOCK_POSE,
        stats: { kind: 'wobbler', massG: 12, diveM: 2.5 },
    },
    {
        id: 'lure.wobbler.deep',
        slot: 'lure',
        nameKey: 'item.lure_wobbler_deep',
        priceCoins: 520,
        reqLevel: 8,
        poseKey: STOCK_POSE,
        stats: { kind: 'wobbler', massG: 16, diveM: 4.5 },
    },
    {
        id: 'lure.jig.14',
        slot: 'lure',
        nameKey: 'item.lure_jig_14',
        priceCoins: 160,
        reqLevel: 2,
        poseKey: STOCK_POSE,
        stats: { kind: 'jig', massG: 14, diveM: 3 },
    },
    {
        id: 'lure.jig.24',
        slot: 'lure',
        nameKey: 'item.lure_jig_24',
        priceCoins: 430,
        reqLevel: 6,
        poseKey: STOCK_POSE,
        stats: { kind: 'jig', massG: 24, diveM: 5 },
    },
    // ── Удочка ─────────────────────────────────────────────────────────────
    //
    // ⚠️ ЭТИ ЗАПИСИ ПЕРЕЕХАЛИ ИЗ «СКОРО», А НЕ ПРИДУМАНЫ ЗАНОВО. Названия, цены
    // и уровни были объявлены в лавке давно и уже переведены на четыре языка;
    // менять их при переносе значило бы обмануть тех, кто на них копил.
    {
        id: 'rod_pole_60',
        slot: 'rod',
        nameKey: 'item.rod_pole_60',
        priceCoins: 380,
        reqLevel: 2,
        poseKey: 'float',
        // Мах: шесть метров, без катушки, мягкий строй. Тест мал — это не
        // слабость, а назначение: удочкой ловят мелкую и среднюю рыбу.
        stats: { kind: 'float', lengthM: 6, testMaxG: 15, action: 'slow' },
    },
    {
        // Телескоп: самая дешёвая удочка в лавке и первая, какую берут. Четыре
        // метра, мягкая, тест невелик — ею и учатся ловить на поплавок.
        id: 'rod_tele_40',
        slot: 'rod',
        nameKey: 'item.rod_tele_40',
        priceCoins: 300,
        reqLevel: 1,
        poseKey: 'float',
        stats: { kind: 'float', lengthM: 4, testMaxG: 20, action: 'slow' },
    },
    {
        /*
         * ⚠️ ШТЕКЕР — ТА ЖЕ МАХОВАЯ, ТОЛЬКО ВДВОЕ ДЛИННЕЕ, И ЭТИМ ОН ЖИВЁТ. Ни
         * катушки, ни колец: снасть подают в точку, а не забрасывают. Девять
         * метров дают то, чего не даст никакая другая безкатушечная снасть, —
         * рабочую точку далеко от берега без единого всплеска.
         */
        id: 'rod_pole_90',
        slot: 'rod',
        nameKey: 'item.rod_pole_90',
        priceCoins: 1500,
        reqLevel: 8,
        poseKey: 'float',
        stats: { kind: 'pole', lengthM: 9, testMaxG: 20, action: 'slow' },
    },
    {
        // Матчевая: дальний заброс поплавка. Катушка и кольца есть, строй
        // быстрее, тест выше — ею достают до бровки, куда маховой не дотянуться.
        id: 'rod_match_42',
        slot: 'rod',
        nameKey: 'item.rod_match_42',
        priceCoins: 780,
        reqLevel: 6,
        poseKey: 'float',
        stats: { kind: 'match', lengthM: 4.2, testMaxG: 25, action: 'medium' },
    },
    {
        // Болонская: катушка, кольца и поплавок. Универсал — ею ловят и в
        // проводку по течению, и на стоячей воде.
        id: 'rod_bolo_50',
        slot: 'rod',
        nameKey: 'item.rod_bolo_50',
        priceCoins: 560,
        reqLevel: 4,
        poseKey: 'float',
        stats: { kind: 'bolo', lengthM: 5, testMaxG: 25, action: 'medium' },
    },
    // ── Спиннинги лавки ────────────────────────────────────────────────────
    //
    // ⚠️ ЭТИ ЧЕТЫРЕ ЖДАЛИ В «СКОРО» И ЖДАЛИ ЗРЯ: снасть у них та же, что у
    // заводского медиума, и работали бы они с первого дня. Не хватало им ровно
    // трёх чисел — длины, теста и строя.
    {
        id: 'rod_spin_ul_21',
        slot: 'rod',
        nameKey: 'item.rod_spin_ul_21',
        priceCoins: 420,
        reqLevel: 3,
        poseKey: STOCK_POSE,
        stats: { kind: 'ultralight', lengthM: 2.1, testMaxG: 7, action: 'medium' },
    },
    {
        // Твичинговый: короткий и быстрый, под рывковую проводку воблера.
        id: 'rod_spin_twitch_21',
        slot: 'rod',
        nameKey: 'item.rod_spin_twitch_21',
        priceCoins: 880,
        reqLevel: 7,
        poseKey: STOCK_POSE,
        stats: { kind: 'light', lengthM: 2.1, testMaxG: 14, action: 'fast' },
    },
    {
        // Джиговый: быстрый строй, чтобы чувствовать дно кончиком.
        id: 'rod_spin_jig_27',
        slot: 'rod',
        nameKey: 'item.rod_spin_jig_27',
        priceCoins: 950,
        reqLevel: 7,
        poseKey: STOCK_POSE,
        stats: { kind: 'medium', lengthM: 2.7, testMaxG: 30, action: 'fast' },
    },
    {
        // Морской: три метра и шестьдесят граммов теста — самый дальний заброс.
        id: 'rod_spin_sea_30',
        slot: 'rod',
        nameKey: 'item.rod_spin_sea_30',
        priceCoins: 1100,
        reqLevel: 9,
        poseKey: STOCK_POSE,
        stats: { kind: 'heavy', lengthM: 3, testMaxG: 60, action: 'medium' },
    },
    // ── Фидеры и карповое ──────────────────────────────────────────────────
    //
    // ⚠️ ФИДЕР — ЭТО КАТУШКА БЕЗ ПОПЛАВКА, И ВСЁ НУЖНОЕ ДЛЯ НЕГО УЖЕ ЕСТЬ.
    // Наживка тонет до дна сама, поклёвка читается по натяжению — ровно как у
    // спиннинга, только на леске червь. Отдельной снастью его делает комплект:
    // поплавка в нём нет, а наживка есть.
    {
        id: 'rod_feeder_33',
        slot: 'rod',
        nameKey: 'item.rod_feeder_33',
        priceCoins: 620,
        reqLevel: 4,
        poseKey: STOCK_POSE,
        stats: { kind: 'feeder', lengthM: 3.3, testMaxG: 60, action: 'medium' },
    },
    {
        id: 'rod_feeder_36',
        slot: 'rod',
        nameKey: 'item.rod_feeder_36',
        priceCoins: 840,
        reqLevel: 6,
        poseKey: STOCK_POSE,
        stats: { kind: 'feeder', lengthM: 3.6, testMaxG: 90, action: 'medium' },
    },
    {
        id: 'rod_feeder_39',
        slot: 'rod',
        nameKey: 'item.rod_feeder_39',
        priceCoins: 1150,
        reqLevel: 9,
        poseKey: STOCK_POSE,
        stats: { kind: 'feeder', lengthM: 3.9, testMaxG: 120, action: 'medium' },
    },
    {
        // Карповое: мягкий строй при огромном тесте — гасит рывки крупной рыбы.
        id: 'rod_carp_36',
        slot: 'rod',
        nameKey: 'item.rod_carp_36',
        priceCoins: 1400,
        reqLevel: 10,
        poseKey: STOCK_POSE,
        stats: { kind: 'feeder', lengthM: 3.6, testMaxG: 150, action: 'slow' },
    },
    // ── Поплавки ───────────────────────────────────────────────────────────
    /*
     * ⚠️ ПОПЛАВКИ РАЗЛИЧАЮТСЯ ТРЕМЯ ЧИСЛАМИ, И ВСЕ ТРИ РАБОТАЮТ В ИГРЕ.
     * Грузоподъёмность — какую наживку удержит и как глубоко его утопит рыба;
     * заметность — насколько рано видно поклёвку; дальность — куда его вообще
     * можно послать. Больше грузоподъёмность — дальше летит, но хуже видно
     * осторожную поклёвку: это и есть выбор, ради которого их несколько.
     */
    {
        // Перо: самый чуткий и самый лёгкий. Мель, штиль, осторожная рыба.
        id: 'float_quill_05',
        slot: 'float',
        nameKey: 'item.float_quill_05',
        priceCoins: 25,
        reqLevel: 1,
        poseKey: 'float',
        stats: { capacityG: 0.5, visibility: 1, castM: 5 },
    },
    {
        id: 'float_light_1g',
        slot: 'float',
        nameKey: 'item.float_light_1g',
        priceCoins: 40,
        reqLevel: 1,
        starter: true,
        poseKey: 'float',
        stats: { capacityG: 1, visibility: 0.9, castM: 8 },
    },
    {
        id: 'float_mid_3g',
        slot: 'float',
        nameKey: 'item.float_mid_3g',
        priceCoins: 90,
        reqLevel: 2,
        poseKey: 'float',
        stats: { capacityG: 3, visibility: 0.75, castM: 14 },
    },
    {
        // Вагглер: глухая огрузка снизу, стоит на ветру и летит далеко.
        id: 'float_waggler_4g',
        slot: 'float',
        nameKey: 'item.float_waggler_4g',
        priceCoins: 120,
        reqLevel: 3,
        poseKey: 'float',
        stats: { capacityG: 4, visibility: 0.7, castM: 20 },
    },
    {
        id: 'float_heavy_6g',
        slot: 'float',
        nameKey: 'item.float_heavy_6g',
        priceCoins: 150,
        reqLevel: 5,
        poseKey: 'float',
        stats: { capacityG: 6, visibility: 0.6, castM: 22 },
    },
    {
        // Скользящий: для глубины больше длины удилища и для дальней бровки.
        id: 'float_slider_8g',
        slot: 'float',
        nameKey: 'item.float_slider_8g',
        priceCoins: 220,
        reqLevel: 7,
        poseKey: 'float',
        stats: { capacityG: 8, visibility: 0.5, castM: 30 },
    },
    // ── Наживка ────────────────────────────────────────────────────────────
    //
    // ⚠️ ВИД НАЖИВКИ — ЭТО СТРОКА ИЗ СПРАВОЧНИКА РЫБЫ, А НЕ НОВОЕ СЛОВО. Червь,
    // опарыш, кукуруза и живец записаны у видов в ряду «чем берётся»; по этим
    // же строкам сервер и решает, кто клюнул. Придумай мы здесь своё написание
    // — наживка не ловила бы никого, и concert выглядел бы как поломка клёва.
    {
        id: 'bait_worm',
        slot: 'lure',
        nameKey: 'item.bait_worm',
        priceCoins: 20,
        reqLevel: 1,
        starter: true,
        poseKey: 'float',
        stats: { kind: 'червь', massG: 3, diveM: 0 },
    },
    {
        id: 'bait_maggot',
        slot: 'lure',
        nameKey: 'item.bait_maggot',
        priceCoins: 25,
        reqLevel: 2,
        poseKey: 'float',
        stats: { kind: 'опарыш', massG: 2, diveM: 0 },
    },
    {
        id: 'bait_corn',
        slot: 'lure',
        nameKey: 'item.bait_corn',
        priceCoins: 15,
        reqLevel: 1,
        poseKey: 'float',
        stats: { kind: 'кукуруза', massG: 4, diveM: 0 },
    },
    {
        id: 'bait_fry',
        slot: 'lure',
        nameKey: 'item.bait_fry',
        priceCoins: 45,
        reqLevel: 4,
        poseKey: 'float',
        stats: { kind: 'живец', massG: 12, diveM: 0 },
    },
];
const BY_ID = new Map(ITEMS.map((i) => [i.id, i]));
export function itemById(id) {
    return BY_ID.get(id);
}
export function itemsBySlot(slot) {
    return ITEMS.filter((i) => i.slot === slot);
}
/** Стартовый набор: то, что есть у игрока с первой секунды и бесплатно. */
export function stockItemIds() {
    return SLOT_ORDER.map((s) => STOCK_ITEMS[s]);
}
export function isStockItem(id) {
    return stockItemIds().includes(id);
}
/**
 * Тип-сторож на слот. Нужен, чтобы `stats` разбирались без приведения типов
 * там, где предмет пришёл строкой из базы.
 */
export function rodStats(def) {
    return def.slot === 'rod' ? def.stats : null;
}
export function reelStats(def) {
    return def.slot === 'reel' ? def.stats : null;
}
export function lineStats(def) {
    return def.slot === 'line' ? def.stats : null;
}
export function lureStats(def) {
    return def.slot === 'lure' ? def.stats : null;
}
/**
 * Порядок закладок в лавке.
 *
 * ⚠️ ПРОДАЖА ПЕРВОЙ, И ОНА ЖЕ ОТКРЫТА ПО УМОЛЧАНИЮ. На базу возвращаются с
 * полным садком: сперва деньги, потом покупки. Поставь мы первой витрину —
 * игрок каждый раз проходил бы мимо неё к кассе и обратно.
 */
export const SHOP_SECTIONS = [
    'sell',
    // ⚠️ ЕДА ВТОРОЙ, СРАЗУ ЗА КАССОЙ, И ЭТО НЕ ПРИХОТЬ. За ней заходят перед
    // каждым выездом и берут по мелочи, а снасть покупают редко и надолго.
    // Стой она предпоследней — до неё пришлось бы всякий раз протаскивать
    // полосу через десять закладок, которые в тот раз не нужны.
    'food',
    'rod',
    'reel',
    'line',
    'leader',
    'hook',
    'lure',
    /*
     * ⚠️ ПОПЛАВКИ СРАЗУ ЗА ПРИМАНКАМИ, И ЭТО НЕ АЛФАВИТ. Поплавок выбирают
     * вместе с наживкой и под ту же рыбу: пришёл за червём — тут же берёшь, чем
     * его держать. Разнеси их по краям полосы, и человек ходил бы туда-сюда.
     */
    'float',
    // ⚠️ НАХЛЫСТ ОТДЕЛЬНЫМ РАЗДЕЛОМ, А НЕ СТРОЧКАМИ В ПРИМАНКАХ. Это не вид
    // приманки, а другая снасть целиком: свой шнур вместо лески, свой подлесок,
    // свои крючки и коробка мушек. Разложи мы это по общим разделам — человек,
    // пришедший за нахлыстом, собирал бы набор по семи закладкам.
    'fly',
    'bait',
    'groundbait',
    'gear',
];
/**
 * Что собрано внутри «Снаряжения», по порядку и с подзаголовками.
 *
 * ⚠️ САДКИ, ЭХОЛОТЫ И ЛОДКИ ОСТАЛИСЬ ОТДЕЛЬНЫМИ РАЗДЕЛАМИ В ДАННЫХ, А НЕ
 * СЛИЛИСЬ В 'gear'. Закладок стало меньше — это про показ; но садок остаётся
 * садком, и когда он заработает, ему понадобится своё место в снаряжении
 * игрока, а не признак «одно из двадцати». Слей мы их в данных — обратно
 * разбирать пришлось бы по названиям.
 */
export const GEAR_GROUPS = ['keepnet', 'sonar', 'boat', 'gear'];
export const SHOP_SOON = [
    // Поводки: отдельно от лески. Тонкий ловчее, стальной держит щуку.
    {
        id: 'lead_fluoro',
        section: 'leader',
        nameKey: 'item.lead_fluoro',
        priceCoins: 90,
        reqLevel: 2,
    },
    { id: 'lead_steel', section: 'leader', nameKey: 'item.lead_steel', priceCoins: 140, reqLevel: 4 },
    // Крючки: засечка и разрывная.
    { id: 'hook_10', section: 'hook', nameKey: 'item.hook_10', priceCoins: 30, reqLevel: 1 },
    { id: 'hook_8', section: 'hook', nameKey: 'item.hook_8', priceCoins: 40, reqLevel: 2 },
    { id: 'hook_6', section: 'hook', nameKey: 'item.hook_6', priceCoins: 55, reqLevel: 4 },
    { id: 'hook_4', section: 'hook', nameKey: 'item.hook_4', priceCoins: 80, reqLevel: 6 },
    // Наживка: расходуемая. Первый настоящий отток денег.
    // Прикормка: поднимает клёв в точке.
    { id: 'gb_basic', section: 'groundbait', nameKey: 'item.gb_basic', priceCoins: 60, reqLevel: 2 },
    { id: 'gb_aroma', section: 'groundbait', nameKey: 'item.gb_aroma', priceCoins: 110, reqLevel: 5 },
    // Еда: сытость. Кончилась — заброс много ближе.
    {
        id: 'food_sandwich',
        section: 'food',
        nameKey: 'item.food_sandwich',
        priceCoins: 25,
        reqLevel: 1,
    },
    { id: 'food_tea', section: 'food', nameKey: 'item.food_tea', priceCoins: 40, reqLevel: 1 },
    { id: 'food_stew', section: 'food', nameKey: 'item.food_stew', priceCoins: 60, reqLevel: 2 },
    { id: 'food_ration', section: 'food', nameKey: 'item.food_ration', priceCoins: 120, reqLevel: 4 },
    // Садок: предел уже введён, расширения — нет.
    { id: 'keep_150', section: 'keepnet', nameKey: 'item.keep_150', priceCoins: 600, reqLevel: 3 },
    { id: 'keep_250', section: 'keepnet', nameKey: 'item.keep_250', priceCoins: 1500, reqLevel: 6 },
    { id: 'keep_400', section: 'keepnet', nameKey: 'item.keep_400', priceCoins: 3200, reqLevel: 10 },
    // Эхолоты: миникарта уже рисует глубины, их можно посадить на прибор.
    {
        id: 'sonar_shore',
        section: 'sonar',
        nameKey: 'item.sonar_shore',
        priceCoins: 1600,
        reqLevel: 7,
    },
    { id: 'sonar_far', section: 'sonar', nameKey: 'item.sonar_far', priceCoins: 3500, reqLevel: 12 },
    // Лодки: ловля не с берега. Самая большая работа из всех.
    { id: 'boat_row', section: 'boat', nameKey: 'item.boat_row', priceCoins: 4000, reqLevel: 9 },
    { id: 'boat_motor', section: 'boat', nameKey: 'item.boat_motor', priceCoins: 9000, reqLevel: 15 },
    // Снаряжение: бивак, свет, одежда и мелочь рыболова — одной закладкой.
    { id: 'net_small', section: 'gear', nameKey: 'item.net_small', priceCoins: 300, reqLevel: 2 },
    { id: 'net_big', section: 'gear', nameKey: 'item.net_big', priceCoins: 850, reqLevel: 6 },
    { id: 'lamp_head', section: 'gear', nameKey: 'item.lamp_head', priceCoins: 250, reqLevel: 2 },
    { id: 'lamp_camp', section: 'gear', nameKey: 'item.lamp_camp', priceCoins: 600, reqLevel: 5 },
    { id: 'tent_solo', section: 'gear', nameKey: 'item.tent_solo', priceCoins: 900, reqLevel: 5 },
    { id: 'tent_duo', section: 'gear', nameKey: 'item.tent_duo', priceCoins: 1800, reqLevel: 9 },
    { id: 'cloth_rain', section: 'gear', nameKey: 'item.cloth_rain', priceCoins: 400, reqLevel: 3 },
    { id: 'cloth_warm', section: 'gear', nameKey: 'item.cloth_warm', priceCoins: 1200, reqLevel: 8 },
    { id: 'gear_chair', section: 'gear', nameKey: 'item.gear_chair', priceCoins: 200, reqLevel: 1 },
    { id: 'gear_box', section: 'gear', nameKey: 'item.gear_box', priceCoins: 350, reqLevel: 3 },
    {
        id: 'gear_thermos',
        section: 'gear',
        nameKey: 'item.gear_thermos',
        priceCoins: 180,
        reqLevel: 2,
    },
    { id: 'gear_scales', section: 'gear', nameKey: 'item.gear_scales', priceCoins: 150, reqLevel: 1 },
    { id: 'gear_tape', section: 'gear', nameKey: 'item.gear_tape', priceCoins: 90, reqLevel: 1 },
    {
        id: 'gear_stringer',
        section: 'gear',
        nameKey: 'item.gear_stringer',
        priceCoins: 700,
        reqLevel: 7,
    },
    // Удилища: объявлено, ещё не работает.
    { id: 'rod_fly_5', section: 'rod', nameKey: 'item.rod_fly_5', priceCoins: 1250, reqLevel: 9 },
    { id: 'rod_fly_8', section: 'rod', nameKey: 'item.rod_fly_8', priceCoins: 1600, reqLevel: 12 },
    {
        id: 'rod_troll_24',
        section: 'rod',
        nameKey: 'item.rod_troll_24',
        priceCoins: 1350,
        reqLevel: 11,
    },
    { id: 'rod_ice', section: 'rod', nameKey: 'item.rod_ice', priceCoins: 180, reqLevel: 3 },
    // Катушки: объявлено, ещё не работает.
    { id: 'reel_1000', section: 'reel', nameKey: 'item.reel_1000', priceCoins: 320, reqLevel: 2 },
    { id: 'reel_2000', section: 'reel', nameKey: 'item.reel_2000', priceCoins: 380, reqLevel: 3 },
    { id: 'reel_5000', section: 'reel', nameKey: 'item.reel_5000', priceCoins: 900, reqLevel: 9 },
    { id: 'reel_8000', section: 'reel', nameKey: 'item.reel_8000', priceCoins: 1700, reqLevel: 12 },
    {
        id: 'reel_baitrunner',
        section: 'reel',
        nameKey: 'item.reel_baitrunner',
        priceCoins: 1300,
        reqLevel: 10,
    },
    { id: 'reel_feeder', section: 'reel', nameKey: 'item.reel_feeder', priceCoins: 760, reqLevel: 6 },
    {
        id: 'reel_rear_drag',
        section: 'reel',
        nameKey: 'item.reel_rear_drag',
        priceCoins: 480,
        reqLevel: 4,
    },
    {
        id: 'reel_carp_big',
        section: 'reel',
        nameKey: 'item.reel_carp_big',
        priceCoins: 2100,
        reqLevel: 13,
    },
    { id: 'reel_multi', section: 'reel', nameKey: 'item.reel_multi', priceCoins: 1900, reqLevel: 12 },
    { id: 'reel_troll', section: 'reel', nameKey: 'item.reel_troll', priceCoins: 2400, reqLevel: 14 },
    { id: 'reel_fly', section: 'reel', nameKey: 'item.reel_fly', priceCoins: 950, reqLevel: 9 },
    { id: 'reel_ice', section: 'reel', nameKey: 'item.reel_ice', priceCoins: 150, reqLevel: 3 },
    // Леска: объявлено, ещё не работает.
    {
        id: 'line_mono_016',
        section: 'line',
        nameKey: 'item.line_mono_016',
        priceCoins: 90,
        reqLevel: 2,
    },
    {
        id: 'line_mono_020',
        section: 'line',
        nameKey: 'item.line_mono_020',
        priceCoins: 110,
        reqLevel: 3,
    },
    {
        id: 'line_mono_028',
        section: 'line',
        nameKey: 'item.line_mono_028',
        priceCoins: 150,
        reqLevel: 5,
    },
    {
        id: 'line_mono_035',
        section: 'line',
        nameKey: 'item.line_mono_035',
        priceCoins: 190,
        reqLevel: 7,
    },
    {
        id: 'line_fluoro_018',
        section: 'line',
        nameKey: 'item.line_fluoro_018',
        priceCoins: 260,
        reqLevel: 4,
    },
    {
        id: 'line_fluoro_028',
        section: 'line',
        nameKey: 'item.line_fluoro_028',
        priceCoins: 340,
        reqLevel: 6,
    },
    {
        id: 'line_braid_010',
        section: 'line',
        nameKey: 'item.line_braid_010',
        priceCoins: 380,
        reqLevel: 5,
    },
    {
        id: 'line_braid_025',
        section: 'line',
        nameKey: 'item.line_braid_025',
        priceCoins: 620,
        reqLevel: 10,
    },
    {
        id: 'line_feeder_022',
        section: 'line',
        nameKey: 'item.line_feeder_022',
        priceCoins: 200,
        reqLevel: 5,
    },
    {
        id: 'line_carp_030',
        section: 'line',
        nameKey: 'item.line_carp_030',
        priceCoins: 340,
        reqLevel: 9,
    },
    {
        id: 'line_ice_012',
        section: 'line',
        nameKey: 'item.line_ice_012',
        priceCoins: 70,
        reqLevel: 3,
    },
    { id: 'line_shock', section: 'line', nameKey: 'item.line_shock', priceCoins: 250, reqLevel: 8 },
    // Поводки: объявлено, ещё не работает.
    { id: 'lead_mono', section: 'leader', nameKey: 'item.lead_mono', priceCoins: 40, reqLevel: 1 },
    { id: 'lead_titan', section: 'leader', nameKey: 'item.lead_titan', priceCoins: 220, reqLevel: 6 },
    {
        id: 'lead_tungsten',
        section: 'leader',
        nameKey: 'item.lead_tungsten',
        priceCoins: 180,
        reqLevel: 5,
    },
    {
        id: 'lead_kevlar',
        section: 'leader',
        nameKey: 'item.lead_kevlar',
        priceCoins: 160,
        reqLevel: 5,
    },
    { id: 'lead_carp', section: 'leader', nameKey: 'item.lead_carp', priceCoins: 120, reqLevel: 8 },
    { id: 'lead_fly', section: 'leader', nameKey: 'item.lead_fly', priceCoins: 130, reqLevel: 9 },
    // Крючки: объявлено, ещё не работает.
    { id: 'hook_14', section: 'hook', nameKey: 'item.hook_14', priceCoins: 20, reqLevel: 1 },
    { id: 'hook_12', section: 'hook', nameKey: 'item.hook_12', priceCoins: 25, reqLevel: 1 },
    { id: 'hook_2', section: 'hook', nameKey: 'item.hook_2', priceCoins: 100, reqLevel: 8 },
    { id: 'hook_1_0', section: 'hook', nameKey: 'item.hook_1_0', priceCoins: 130, reqLevel: 9 },
    { id: 'hook_treble', section: 'hook', nameKey: 'item.hook_treble', priceCoins: 60, reqLevel: 3 },
    { id: 'hook_double', section: 'hook', nameKey: 'item.hook_double', priceCoins: 50, reqLevel: 3 },
    { id: 'hook_offset', section: 'hook', nameKey: 'item.hook_offset', priceCoins: 70, reqLevel: 5 },
    { id: 'hook_carp', section: 'hook', nameKey: 'item.hook_carp', priceCoins: 90, reqLevel: 8 },
    // Приманки: объявлено, ещё не работает.
    {
        id: 'lure_spoon_7',
        section: 'lure',
        nameKey: 'item.lure_spoon_7',
        priceCoins: 120,
        reqLevel: 2,
    },
    {
        id: 'lure_spoon_28',
        section: 'lure',
        nameKey: 'item.lure_spoon_28',
        priceCoins: 200,
        reqLevel: 6,
    },
    {
        id: 'lure_spinner_3',
        section: 'lure',
        nameKey: 'item.lure_spinner_3',
        priceCoins: 100,
        reqLevel: 1,
    },
    {
        id: 'lure_spinner_14',
        section: 'lure',
        nameKey: 'item.lure_spinner_14',
        priceCoins: 210,
        reqLevel: 7,
    },
    {
        id: 'lure_minnow_90',
        section: 'lure',
        nameKey: 'item.lure_minnow_90',
        priceCoins: 320,
        reqLevel: 5,
    },
    {
        id: 'lure_crank_60',
        section: 'lure',
        nameKey: 'item.lure_crank_60',
        priceCoins: 280,
        reqLevel: 4,
    },
    {
        id: 'lure_shad_70',
        section: 'lure',
        nameKey: 'item.lure_shad_70',
        priceCoins: 300,
        reqLevel: 5,
    },
    {
        id: 'lure_popper_80',
        section: 'lure',
        nameKey: 'item.lure_popper_80',
        priceCoins: 340,
        reqLevel: 6,
    },
    {
        id: 'lure_walker_95',
        section: 'lure',
        nameKey: 'item.lure_walker_95',
        priceCoins: 360,
        reqLevel: 7,
    },
    {
        id: 'lure_jerk_130',
        section: 'lure',
        nameKey: 'item.lure_jerk_130',
        priceCoins: 620,
        reqLevel: 10,
    },
    {
        id: 'lure_swim_150',
        section: 'lure',
        nameKey: 'item.lure_swim_150',
        priceCoins: 780,
        reqLevel: 12,
    },
    {
        id: 'lure_jighead_12',
        section: 'lure',
        nameKey: 'item.lure_jighead_12',
        priceCoins: 60,
        reqLevel: 3,
    },
    {
        id: 'lure_sil_worm',
        section: 'lure',
        nameKey: 'item.lure_sil_worm',
        priceCoins: 80,
        reqLevel: 3,
    },
    {
        id: 'lure_sil_shad',
        section: 'lure',
        nameKey: 'item.lure_sil_shad',
        priceCoins: 90,
        reqLevel: 3,
    },
    {
        id: 'lure_sil_twister',
        section: 'lure',
        nameKey: 'item.lure_sil_twister',
        priceCoins: 85,
        reqLevel: 3,
    },
    {
        id: 'lure_mandula',
        section: 'lure',
        nameKey: 'item.lure_mandula',
        priceCoins: 140,
        reqLevel: 5,
    },
    {
        id: 'lure_fly_wet',
        section: 'lure',
        nameKey: 'item.lure_fly_wet',
        priceCoins: 70,
        reqLevel: 9,
    },
    {
        id: 'lure_fly_dry',
        section: 'lure',
        nameKey: 'item.lure_fly_dry',
        priceCoins: 75,
        reqLevel: 9,
    },
    // Наживка: объявлено, ещё не работает.
    {
        id: 'bait_bloodworm',
        section: 'bait',
        nameKey: 'item.bait_bloodworm',
        priceCoins: 30,
        reqLevel: 2,
    },
    { id: 'bait_barley', section: 'bait', nameKey: 'item.bait_barley', priceCoins: 12, reqLevel: 1 },
    { id: 'bait_dough', section: 'bait', nameKey: 'item.bait_dough', priceCoins: 10, reqLevel: 1 },
    { id: 'bait_peas', section: 'bait', nameKey: 'item.bait_peas', priceCoins: 14, reqLevel: 2 },
    { id: 'bait_boilie', section: 'bait', nameKey: 'item.bait_boilie', priceCoins: 70, reqLevel: 6 },
    {
        id: 'bait_pellets',
        section: 'bait',
        nameKey: 'item.bait_pellets',
        priceCoins: 55,
        reqLevel: 5,
    },
    { id: 'bait_mussel', section: 'bait', nameKey: 'item.bait_mussel', priceCoins: 35, reqLevel: 4 },
    { id: 'bait_shrimp', section: 'bait', nameKey: 'item.bait_shrimp', priceCoins: 40, reqLevel: 5 },
    { id: 'bait_bread', section: 'bait', nameKey: 'item.bait_bread', priceCoins: 8, reqLevel: 1 },
    { id: 'bait_cheese', section: 'bait', nameKey: 'item.bait_cheese', priceCoins: 25, reqLevel: 3 },
    // Прикормка: объявлено, ещё не работает.
    { id: 'gb_bream', section: 'groundbait', nameKey: 'item.gb_bream', priceCoins: 90, reqLevel: 3 },
    { id: 'gb_carp', section: 'groundbait', nameKey: 'item.gb_carp', priceCoins: 120, reqLevel: 5 },
    { id: 'gb_roach', section: 'groundbait', nameKey: 'item.gb_roach', priceCoins: 80, reqLevel: 2 },
    {
        id: 'gb_feeder',
        section: 'groundbait',
        nameKey: 'item.gb_feeder',
        priceCoins: 130,
        reqLevel: 6,
    },
    {
        id: 'gb_winter',
        section: 'groundbait',
        nameKey: 'item.gb_winter',
        priceCoins: 100,
        reqLevel: 4,
    },
    { id: 'gb_dip', section: 'groundbait', nameKey: 'item.gb_dip', priceCoins: 150, reqLevel: 7 },
    { id: 'gb_pva', section: 'groundbait', nameKey: 'item.gb_pva', priceCoins: 180, reqLevel: 8 },
    { id: 'gb_soil', section: 'groundbait', nameKey: 'item.gb_soil', priceCoins: 60, reqLevel: 3 },
    // Еда: объявлено, ещё не работает.
    { id: 'food_soup', section: 'food', nameKey: 'item.food_soup', priceCoins: 90, reqLevel: 4 },
    { id: 'food_coffee', section: 'food', nameKey: 'item.food_coffee', priceCoins: 35, reqLevel: 1 },
    { id: 'food_energy', section: 'food', nameKey: 'item.food_energy', priceCoins: 60, reqLevel: 3 },
    { id: 'food_bar', section: 'food', nameKey: 'item.food_bar', priceCoins: 20, reqLevel: 1 },
    // Садки: объявлено, ещё не работает.
    { id: 'keep_60', section: 'keepnet', nameKey: 'item.keep_60', priceCoins: 220, reqLevel: 3 },
    { id: 'keep_cage', section: 'keepnet', nameKey: 'item.keep_cage', priceCoins: 300, reqLevel: 5 },
    { id: 'keep_sack', section: 'keepnet', nameKey: 'item.keep_sack', priceCoins: 520, reqLevel: 9 },
    // Эхолоты: объявлено, ещё не работает.
    {
        id: 'sonar_wireless',
        section: 'sonar',
        nameKey: 'item.sonar_wireless',
        priceCoins: 1500,
        reqLevel: 9,
    },
    {
        id: 'sonar_color',
        section: 'sonar',
        nameKey: 'item.sonar_color',
        priceCoins: 2600,
        reqLevel: 12,
    },
    { id: 'sonar_ice', section: 'sonar', nameKey: 'item.sonar_ice', priceCoins: 1200, reqLevel: 8 },
    // Лодки: объявлено, ещё не работает.
    { id: 'boat_pvc', section: 'boat', nameKey: 'item.boat_pvc', priceCoins: 3200, reqLevel: 11 },
    {
        id: 'boat_outboard',
        section: 'boat',
        nameKey: 'item.boat_outboard',
        priceCoins: 4500,
        reqLevel: 14,
    },
    { id: 'boat_mount', section: 'boat', nameKey: 'item.boat_mount', priceCoins: 400, reqLevel: 11 },
    { id: 'boat_anchor', section: 'boat', nameKey: 'item.boat_anchor', priceCoins: 260, reqLevel: 8 },
    // Снаряжение: объявлено, ещё не работает.
    {
        id: 'gear_forceps',
        section: 'gear',
        nameKey: 'item.gear_forceps',
        priceCoins: 60,
        reqLevel: 2,
    },
    { id: 'gear_pliers', section: 'gear', nameKey: 'item.gear_pliers', priceCoins: 90, reqLevel: 3 },
    { id: 'gear_mat', section: 'gear', nameKey: 'item.gear_mat', priceCoins: 300, reqLevel: 9 },
    {
        id: 'gear_rodpod',
        section: 'gear',
        nameKey: 'item.gear_rodpod',
        priceCoins: 480,
        reqLevel: 10,
    },
    {
        id: 'gear_umbrella',
        section: 'gear',
        nameKey: 'item.gear_umbrella',
        priceCoins: 340,
        reqLevel: 6,
    },
    { id: 'gear_bag', section: 'gear', nameKey: 'item.gear_bag', priceCoins: 240, reqLevel: 4 },
    { id: 'gear_bucket', section: 'gear', nameKey: 'item.gear_bucket', priceCoins: 70, reqLevel: 2 },
    { id: 'gear_polar', section: 'gear', nameKey: 'item.gear_polar', priceCoins: 280, reqLevel: 6 },
    // Нахлыст под вторую сотню видов.
    { id: 'fly_line_5', section: 'fly', nameKey: 'item.fly_line_5', priceCoins: 680, reqLevel: 9 },
    { id: 'fly_line_8', section: 'fly', nameKey: 'item.fly_line_8', priceCoins: 760, reqLevel: 12 },
    { id: 'fly_backing', section: 'fly', nameKey: 'item.fly_backing', priceCoins: 180, reqLevel: 9 },
    { id: 'fly_tippet', section: 'fly', nameKey: 'item.fly_tippet', priceCoins: 150, reqLevel: 9 },
    { id: 'fly_box', section: 'fly', nameKey: 'item.fly_box', priceCoins: 260, reqLevel: 9 },
    { id: 'fly_dry_set', section: 'fly', nameKey: 'item.fly_dry_set', priceCoins: 420, reqLevel: 9 },
    { id: 'fly_wet_set', section: 'fly', nameKey: 'item.fly_wet_set', priceCoins: 400, reqLevel: 9 },
    {
        id: 'fly_nymph_set',
        section: 'fly',
        nameKey: 'item.fly_nymph_set',
        priceCoins: 440,
        reqLevel: 10,
    },
    {
        id: 'fly_streamer',
        section: 'fly',
        nameKey: 'item.fly_streamer',
        priceCoins: 280,
        reqLevel: 10,
    },
    { id: 'fly_hegene', section: 'fly', nameKey: 'item.fly_hegene', priceCoins: 320, reqLevel: 10 },
    {
        id: 'fly_floatant',
        section: 'fly',
        nameKey: 'item.fly_floatant',
        priceCoins: 120,
        reqLevel: 9,
    },
    { id: 'fly_sink', section: 'fly', nameKey: 'item.fly_sink', priceCoins: 120, reqLevel: 10 },
    { id: 'fly_vice', section: 'fly', nameKey: 'item.fly_vice', priceCoins: 900, reqLevel: 13 },
    // Наживка под вторую сотню видов.
    { id: 'bait_caddis', section: 'bait', nameKey: 'item.bait_caddis', priceCoins: 35, reqLevel: 3 },
    { id: 'bait_roe', section: 'bait', nameKey: 'item.bait_roe', priceCoins: 80, reqLevel: 7 },
    { id: 'bait_cut', section: 'bait', nameKey: 'item.bait_cut', priceCoins: 45, reqLevel: 6 },
    {
        id: 'bait_grasshopper',
        section: 'bait',
        nameKey: 'item.bait_grasshopper',
        priceCoins: 20,
        reqLevel: 2,
    },
    { id: 'bait_algae', section: 'bait', nameKey: 'item.bait_algae', priceCoins: 15, reqLevel: 3 },
    { id: 'bait_frog', section: 'bait', nameKey: 'item.bait_frog', priceCoins: 90, reqLevel: 9 },
    { id: 'bait_fruit', section: 'bait', nameKey: 'item.bait_fruit', priceCoins: 30, reqLevel: 8 },
    { id: 'bait_meat', section: 'bait', nameKey: 'item.bait_meat', priceCoins: 40, reqLevel: 8 },
    {
        id: 'bait_mussel_tropic',
        section: 'bait',
        nameKey: 'item.bait_mussel_tropic',
        priceCoins: 50,
        reqLevel: 9,
    },
    // Поводки под вторую сотню видов.
    {
        id: 'lead_wire_20',
        section: 'leader',
        nameKey: 'item.lead_wire_20',
        priceCoins: 260,
        reqLevel: 10,
    },
    {
        id: 'lead_wire_40',
        section: 'leader',
        nameKey: 'item.lead_wire_40',
        priceCoins: 380,
        reqLevel: 13,
    },
    {
        id: 'lead_shock_heavy',
        section: 'leader',
        nameKey: 'item.lead_shock_heavy',
        priceCoins: 300,
        reqLevel: 12,
    },
    {
        id: 'lead_mono_heavy',
        section: 'leader',
        nameKey: 'item.lead_mono_heavy',
        priceCoins: 200,
        reqLevel: 11,
    },
    // Крючки под вторую сотню видов.
    { id: 'hook_3_0', section: 'hook', nameKey: 'item.hook_3_0', priceCoins: 160, reqLevel: 10 },
    { id: 'hook_6_0', section: 'hook', nameKey: 'item.hook_6_0', priceCoins: 210, reqLevel: 12 },
    {
        id: 'hook_circle',
        section: 'hook',
        nameKey: 'item.hook_circle',
        priceCoins: 140,
        reqLevel: 10,
    },
    { id: 'hook_fly', section: 'hook', nameKey: 'item.hook_fly', priceCoins: 110, reqLevel: 9 },
    // Снаряжение под вторую сотню видов.
    { id: 'gear_waders', section: 'gear', nameKey: 'item.gear_waders', priceCoins: 760, reqLevel: 7 },
    { id: 'gear_boots', section: 'gear', nameKey: 'item.gear_boots', priceCoins: 420, reqLevel: 7 },
    { id: 'gear_glove', section: 'gear', nameKey: 'item.gear_glove', priceCoins: 130, reqLevel: 10 },
    {
        id: 'gear_lipgrip',
        section: 'gear',
        nameKey: 'item.gear_lipgrip',
        priceCoins: 290,
        reqLevel: 10,
    },
    { id: 'gear_gaff', section: 'gear', nameKey: 'item.gear_gaff', priceCoins: 350, reqLevel: 13 },
    { id: 'gear_cooler', section: 'gear', nameKey: 'item.gear_cooler', priceCoins: 380, reqLevel: 6 },
    {
        id: 'gear_repellent',
        section: 'gear',
        nameKey: 'item.gear_repellent',
        priceCoins: 80,
        reqLevel: 3,
    },
    { id: 'gear_marker', section: 'gear', nameKey: 'item.gear_marker', priceCoins: 180, reqLevel: 8 },
];
/** Что лежит в закладке: работающее и объявленное по отдельности. */
export function shopSection(s) {
    const гнездо = SLOT_ORDER.find((г) => г === s);
    return {
        /*
         * ⚠️ СТАРТОВОЕ ТОЖЕ НА ВИТРИНЕ. Прежде оно отсеивалось по нулевой цене — и
         * это было не решение, а следствие: раз цены нет, продавать нечем.
         *
         * А показывать его надо: витрина — это ЛЕСТНИЦА, и без первой ступени по
         * ней не понять, где стоишь. Игрок видел «Лайт за 450» и «Хеви за 1400», не
         * зная, чего стоит то, что у него уже в руках, — и не мог рассудить, стоит
         * ли копить. Теперь у стартового есть цена, и она на ступень ниже
         * ближайшего: 250 против 450 у удилищ, 400 против 900 у катушек.
         *
         * Купить второе такое же нельзя: лавка сама ставит «куплено» тому, что уже
         * в рюкзаке, и строка перестаёт нажиматься.
         */
        items: гнездо === undefined ? [] : ITEMS.filter((i) => i.slot === гнездо),
        soon: SHOP_SOON.filter((i) => i.section === s),
    };
}
//# sourceMappingURL=catalog.js.map